import { SvgIcon, SvgIconProps } from '@mui/material';

const CloseOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="CloseOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M18.5867 19.9963L19.9967 18.5863L13.4096 11.9992L19.9988 5.41428L18.5867 4.0022L11.9996 10.5892L5.40675 4.00812L4.00266 5.41221L10.5896 11.9992L4.00259 18.5862L5.41259 19.9962L11.9996 13.4092L18.5867 19.9963Z" />
    </SvgIcon>
  );
};

export default CloseOutlined;
